import React from "react";
import { getRpeCellStyle } from "../coachingHelpers";

const RPE_LEGEND = [
  { rpe: 5, label: "≤5" },
  { rpe: 6, label: "6" },
  { rpe: 7, label: "7" },
  { rpe: 8, label: "8" },
  { rpe: 9, label: "9–10" },
];

export function MetricLegend({ metric, t }) {
  if (!metric || metric === "workouts" || metric === "check-in") {
    return (
      <div className="legend">
        <span>
          <span className="legend-check">✓</span>
          {t("coachingDashboard.legend.completed")}
        </span>
        <span>
          <span className="legend-missed">‼</span>
          {t("coachingDashboard.legend.missed")}
        </span>
        <span>
          <span className="legend-dot" />
          {t("coachingDashboard.legend.scheduled")}
        </span>
      </div>
    );
  }
  if (metric === "sessionRPE") {
    return (
      <div className="legend">
        {RPE_LEGEND.map(({ rpe, label }) => (
          <span key={rpe} className="rpe-legend-item">
            <i style={getRpeCellStyle(rpe)} />
            {t("coachingDashboard.rpeLegend", { range: label })}
          </span>
        ))}
      </div>
    );
  }
  return (
    <div className="legend">
      <span>
        <span className="legend-square" />
        {t("coachingDashboard.legend.logged")}
      </span>
    </div>
  );
}
